<template>
  <div class="home ruderclub-dark-green">
    <img
      src="../assets/img/club-logo-eckig.png"
      class="img-fluid"
      style="max-height: 60vh"
      alt="Ruderclub Speck-weg"
    />
    <div>
      <router-link to="/login" class="btn btn-outline-ruderclub-orange">
        Zum Login
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Home",
};
</script>

<style scoped>
.home {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  text-align: center;
}
</style>
